import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorText } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { useNoIndex } from "@/hooks/useSeo";

const field = "w-full rounded-sm border border-line bg-surface px-3 py-3 text-sm outline-none focus:border-brand";

export default function AdminLogin() {
  const { user, login } = useAuth();
  useNoIndex();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(email, password); } catch (e2) { setErr(errorText(e2)); }
    setBusy(false);
  };
  return (
    <main className="grid min-h-screen place-items-center bg-surface px-4 grain relative">
      <form onSubmit={submit} className="card-dark relative z-10 w-full max-w-md space-y-5 p-8" data-testid="admin-login-form">
        <Link to="/"><Logo /></Link>
        <h1 className="flex items-center gap-2 text-3xl font-bold uppercase"><Lock size={22} className="text-brand" /> Panel del taller</h1>
        <label className="block text-xs uppercase tracking-wider text-mute">Correo
          <input type="email" required autoComplete="email" className={`${field} mt-1`} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" />
        </label>
        <label className="block text-xs uppercase tracking-wider text-mute">Contraseña
          <input type="password" required autoComplete="current-password" className={`${field} mt-1`} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" />
        </label>
        {err && <p role="alert" className="text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
        <button className="btn-gold w-full" disabled={busy} data-testid="admin-login-submit-btn">{busy && <Loader2 size={16} className="animate-spin" />} Entrar</button>
      </form>
    </main>
  );
}
